import { render, staticRenderFns } from "./ReservoirWaterRegime.vue?vue&type=template&id=16812ece&scoped=true&"
import script from "./ReservoirWaterRegime.vue?vue&type=script&lang=js&"
export * from "./ReservoirWaterRegime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16812ece",
  null
  
)

export default component.exports